import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../../../environments/environment';

export interface ContactDTO {
  recaptcha: string;
  subject: string;
  country: string;
  firstName: string;
  lastName: string;
  email: string;
  message: string;
}

@Injectable({
  providedIn: 'root'
})
export class ContactService {

  constructor(private http: HttpClient) {
  }

  save(contactDTO: ContactDTO): Observable<any> {
    return this.http.post(environment.apiBase + 'contact/submit', contactDTO);
  }
}
